import React from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash.isempty";
import ErrorMessage from "components/v3/error-message/ErrorMessage";
import { THEMES } from "common/constants/Constants";
import styles from "./styles.module.scss";

const SubmitError = ({ error, onClick, theme = THEMES.ERROR_THEME_MODULE_LEVEL }) => {
    if (isEmpty(error)) {
        return null;
    }

    const className = `${ styles.error } ${ styles[theme] }`;

    if (onClick) {
        return (
            <button className={ `${ className } ${ styles.hasClick }` } type="button" onClick={ onClick }>
                <ErrorMessage error={ error } theme={ theme } />
            </button>
        );
    }

    return (
        <div className={ className }>
            <ErrorMessage error={ error } theme={ theme } />
        </div>
    );
};

SubmitError.propTypes = {
    error: PropTypes.shape({
        type: PropTypes.string,
        message: PropTypes.string.isRequired
    }),
    onClick: PropTypes.func
};

export default SubmitError;
